// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Form,
//   InputGroup,
//   Badge,
//   Button,
// } from "react-bootstrap";
// import {
//   IconPlus,
//   IconMinus,
//   IconChevronLeft,
//   IconChevronRight,
//   IconBolt,
//   IconTrash,
// } from "@tabler/icons-react";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import { useParams } from "react-router-dom";
// import usePostRequest from "../../hooks/usePostRequest";
// import { useForm, Controller } from "react-hook-form";
// import moment from "moment";

// function FBOPForm() {
//   const { zip_id } = useParams();
//   const { data: documentData, postData: fetchData } = usePostRequest(
//     API_ENDPOINTS.GET_SINGLE_FBOP,
//   );

//   const {
//     register,
//     control,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm({
//     defaultValues: {},
//   });

//   const [zoom, setZoom] = useState(1);

//   const [position, setPosition] = useState({ x: 0, y: 0 });
//   const [isDragging, setIsDragging] = useState(false);
//   const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

//   const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
//   const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));
//   const [page, setPage] = useState(1);

//   const imgUrl = process.env.REACT_APP_BASE_URL_IMG;

//   console.log("FBOP Document Data:", documentData?.image);

//   useEffect(() => {
//     fetchData({ auto_id: zip_id, page: page });
//   }, [zip_id, page]);

//   const handleMouseDown = (e) => {
//     e.preventDefault();
//     setIsDragging(true);

//     setDragStart({
//       x: e.clientX - position.x,
//       y: e.clientY - position.y,
//     });
//   };

//   const handleMouseMove = (e) => {
//     if (!isDragging) return;
//     e.preventDefault();
//     setPosition({
//       x: e.clientX - dragStart.x,
//       y: e.clientY - dragStart.y,
//     });
//   };

//   const handleMouseUp = () => {
//     setIsDragging(false);
//   };

//   const customStyles = {
//     dotBackground: {
//       backgroundColor: "#f8fafc",
//       backgroundImage: "radial-gradient(#cbd5e1 1px, transparent 0)",
//       backgroundSize: "24px 24px",
//       borderRadius: "8px",
//       overflow: "hidden",
//       position: "relative",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: isDragging ? "grabbing" : zoom > 1 ? "grab" : "default",
//     },
//     imageStyle: {
//       transition: isDragging ? "none" : "transform 0.3s ease",

//       transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
//       maxWidth: "90%",
//       maxHeight: "90%",
//       boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
//       borderRadius: "4px",
//       userSelect: "none",
//     },
//     sectionTitle: {
//       fontSize: "12px",
//       fontWeight: "700",
//       color: "#94a3b8",
//       letterSpacing: "0.05em",
//       borderLeft: "3px solid #1e293b",
//       paddingLeft: "10px",
//     },
//     inputStyle: {
//       backgroundColor: "#f8fafc",
//       border: "1px solid #e2e8f0",
//       borderRadius: "8px",
//       fontSize: "14px",
//       color: "#334155",
//     },
//     unitAddon: {
//       backgroundColor: "#f1f5f9",
//       border: "1px solid #e2e8f0",
//       fontSize: "12px",
//       color: "#94a3b8",
//       padding: "0 12px",
//     },
//   };

//   useEffect(() => {
//     if (documentData?.data) {
//       const data = documentData.data;

//       setValue(
//         "reportDate",
//         data?.date ? moment(data?.date).format("MM/DD/YYYY") : null,
//       );
//       setValue(
//         "dateSized",
//         data?.date_sized ? moment(data?.date_sized).format("MM/DD/YYYY") : null,
//       );
//       setValue("sizedBy", data.sized_by || "");
//       setValue("location", data.fbop_loc || "");
//       setValue("firstName", data.officer_first_name || " ");
//       setValue("lastName", data.officer_last_name || "");
//       setValue("height", data.height || "");
//       setValue("weight", data.weight || "");
//       setValue("chest", data.chest || "");
//       setValue("waist", data.waist || "");
//       setValue("frontSeated", data.front_seated || "");
//       setValue("frontStanding", data.front_standing || "");
//       setValue("back", data.back || "");
//       setValue("carrierType", data.v_carrier_type || "");
//       setValue("carrierQty", data.v_carrier_qty || "");
//       setValue("carryBag", data.v_carry_bag || "");
//       setValue("tails", data.v_tails || "");
//       setValue("comments", data.additional_comments || "");
//     }
//   }, [documentData, setValue]);

//   return (
//     <div className="bg-light min-vh-100 p-4">
//       <Container>
//         <Row className="g-4">
//           <Col lg={7}>
//             <Card
//               className="border-0 shadow-sm rounded-4 overflow-hidden"
//               style={{ height: "85vh" }}
//             >
//               <div className="p-3 flex-grow-1 d-flex flex-column h-100">
//                 <div
//                   className="flex-grow-1 border p-2"
//                   style={customStyles.dotBackground}
//                   onMouseDown={handleMouseDown}
//                   onMouseMove={handleMouseMove}
//                   onMouseUp={handleMouseUp}
//                   onMouseLeave={handleMouseUp}
//                 >
//                   <div className="position-absolute top-0 end-0 m-3 d-flex flex-column gap-2 z-3">
//                     <Button
//                       onClick={handleZoomIn}
//                       variant="light"

//                       className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
//                       style={{
//                         width: "30px",
//                         height: "30px",
//                         minWidth: "auto",
//                         backgroundColor: "#fff",
//                       }}
//                     >
//                       <IconPlus size={16} stroke={2.5} />
//                     </Button>

//                     <Button
//                       onClick={handleZoomOut}
//                       variant="light"
//                       className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
//                       style={{
//                         width: "30px",
//                         height: "30px",
//                         minWidth: "auto",
//                         backgroundColor: "#fff",
//                       }}
//                     >
//                       <IconMinus size={16} stroke={2.5} />
//                     </Button>
//                   </div>

//                   <img
//                     src={`${imgUrl}${documentData?.data?.image}`}
//                     alt="Document"
//                     style={customStyles.imageStyle}
//                     draggable={false}
//                   />
//                 </div>

//                 {/* Left Footer Pagination */}
//                 <div className="pt-3 d-flex justify-content-between align-items-center">
//                   <span className="text-muted small fw-medium">
//                     Page {page} of {documentData?.totalRecords}
//                   </span>
//                   <Button
//                     variant="outline-primary"
//                     size="sm"
//                     className="rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
//                     style={{
//                       fontSize: "0.85rem",
//                       borderColor: "#db4a22",
//                       color: "#db4a22",
//                       backgroundColor: "transparent",
//                     }}
//                     // onClick={() =>
//                     //   navigate(`/fbop-data/${doc.auto_id}`)
//                     // }
//                   >
//                     Delete <IconTrash size={14} />
//                   </Button>
//                   <Button
//                     variant="outline-secondary"
//                     size="sm"
//                     className="px-3 border-light-subtle rounded-3 text-dark d-flex align-items-center gap-1"
//                     // onClick={() => setPage((prev) => prev - 1)}
//                   >
//                     Update
//                   </Button>
//                   <div className="d-flex gap-2">
//                     <Button
//                       variant="outline-secondary"
//                       size="sm"
//                       className="px-3 border-light-subtle rounded-3 text-dark d-flex align-items-center gap-1"
//                       onClick={() => setPage((prev) => prev - 1)}
//                       disabled={page <= 1}
//                     >
//                       <IconChevronLeft size={16} /> Previous
//                     </Button>
//                     <Button
//                       variant="outline-secondary"
//                       size="sm"
//                       className="px-3 border-light-subtle rounded-3 text-dark d-flex align-items-center gap-1"
//                       onClick={() => setPage((prev) => prev + 1)}
//                       disabled={page >= documentData?.totalRecords}
//                     >
//                       Next <IconChevronRight size={16} />
//                     </Button>
//                   </div>
//                 </div>
//               </div>
//             </Card>
//           </Col>

//           {/* RIGHT SIDE: AI DATA PANEL */}
//           <Col lg={5}>
//             <Card
//               className="border-0 shadow-sm rounded-4 overflow-hidden"
//               style={{ height: "85vh" }}
//             >
//               {/* Header */}
//               <Card.Header className="bg-white border-bottom p-3 d-flex justify-content-between align-items-center pt-4">
//                 <div className="d-flex align-items-center gap-2">
//                   <div
//                     className="p-1 rounded-2"
//                     style={{ backgroundColor: "#f0f2ff" }}
//                   >
//                     <IconBolt size={20} color="#FE6338" fill="#FE6338" />
//                   </div>
//                   <h6 className="mb-0 fw-bold" style={{ color: "#1e293b" }}>
//                     Extracted Data
//                   </h6>
//                 </div>
//               </Card.Header>

//               {/* Scrollable Form Body */}
//               <div
//                 className="overflow-auto flex-grow-1 p-4 pt-2"
//                 style={{ scrollbarWidth: "thin" }}
//               >
//                 {/* GENERAL INFORMATION */}
//                 <div className="mt-2 mb-3" style={customStyles.sectionTitle}>
//                   GENERAL INFORMATION
//                 </div>

//                 <Row className="g-3 mb-3">
//                   <Col>
//                     <Form.Label className="fw-semibold">Report Date</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       // type="date"
//                       {...register("reportDate")}
//                       disabled
//                     />
//                   </Col>
//                   <Col>
//                     <Form.Label className="fw-semibold">Date Sized</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("dateSized")}
//                       disabled
//                     />
//                   </Col>
//                 </Row>

//                 <Row className="g-3 mb-3">
//                   <Col>
//                     <Form.Label className="fw-semibold">Sized By</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("sizedBy")}
//                       disabled
//                     />
//                   </Col>
//                   <Col>
//                     <Form.Label className="fw-semibold">Location</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("location")}
//                       disabled
//                     />
//                   </Col>
//                 </Row>

//                 {/* OFFICER DETAILS */}
//                 <div className="mt-4 mb-3" style={customStyles.sectionTitle}>
//                   OFFICER DETAILS
//                 </div>

//                 <Row className="g-3 mb-3">
//                   <Col>
//                     <Form.Label className="fw-semibold">First Name</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("firstName")}
//                       disabled
//                     />
//                   </Col>
//                   <Col>
//                     <Form.Label className="fw-semibold">Last Name</Form.Label>
//                     <Form.Control
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("lastName")}
//                       disabled
//                     />
//                   </Col>
//                 </Row>

//                 {/* MEASUREMENTS */}
//                 <div className="mt-4 mb-3" style={customStyles.sectionTitle}>
//                   MEASUREMENTS
//                 </div>

//                 <Row className="g-3 mb-3">
//                   <Col md={6}>
//                     <Form.Label className="fw-semibold">Height</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("height")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Label className="fw-semibold">Weight</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("weight")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         lbs
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Label className="fw-semibold">Chest</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("chest")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Label className="fw-semibold">Waist</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("waist")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                 </Row>

//                 <Row className="mb-4 g-2">
//                   <Col xs={4}>
//                     <Form.Label className="fw-semibold">Fr. Seated</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("frontSeated")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                   <Col xs={4}>
//                     <Form.Label className="fw-semibold">
//                       Fr. Standing
//                     </Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("frontStanding")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                   <Col xs={4}>
//                     <Form.Label className="fw-semibold">Back</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("back")}
//                         disabled
//                       />
//                       <InputGroup.Text style={customStyles.unitAddon}>
//                         in
//                       </InputGroup.Text>
//                     </InputGroup>
//                   </Col>
//                 </Row>

//                 <div className="mt-4 mb-3" style={customStyles.sectionTitle}>
//                   EQUIPMENT
//                 </div>

//                 <Row className="mb-4 g-3">
//                   <Col xs={6}>
//                     <Form.Label className="fw-semibold">
//                       Carrier Type
//                     </Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("carrierType")}
//                         disabled
//                       />
//                     </InputGroup>
//                   </Col>
//                   <Col xs={6}>
//                     <Form.Label className="fw-semibold">Carrier Qty</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("carrierQty")}
//                         disabled
//                       />
//                     </InputGroup>
//                   </Col>
//                   <Col xs={6}>
//                     <Form.Label className="fw-semibold"> Carry Bag</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("carryBag")}
//                         disabled
//                       />
//                     </InputGroup>
//                   </Col>
//                   <Col xs={6}>
//                     <Form.Label className="fw-semibold">Tails</Form.Label>
//                     <InputGroup>
//                       <Form.Control
//                         style={customStyles.inputStyle}
//                         {...register("tails")}
//                         disabled
//                       />
//                     </InputGroup>
//                   </Col>
//                 </Row>

//                 <div className="mt-4 mb-3" style={customStyles.sectionTitle}>
//                   COMMENTS
//                 </div>

//                 <Row className="mb-3">
//                   <Col xs={12}>
//                     <Form.Label className="fw-semibold">
//                       Additional Comments
//                     </Form.Label>
//                     <Form.Control
//                       as="textarea"
//                       rows={3}
//                       style={customStyles.inputStyle}
//                       className="py-2"
//                       {...register("comments")}
//                       disabled
//                     />
//                   </Col>
//                 </Row>
//               </div>
//             </Card>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// }

// export default FBOPForm;

import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Button,
} from "react-bootstrap";
import {
  IconPlus,
  IconMinus,
  IconChevronLeft,
  IconChevronRight,
  IconBolt,
  IconTrash,
} from "@tabler/icons-react";
import { API_ENDPOINTS } from "../../constant/_constant";
import { useNavigate, useParams } from "react-router-dom";
import usePostRequest from "../../hooks/usePostRequest";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import moment from "moment";
import { toast } from "react-toastify";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";

function FBOPForm() {
  const { zip_id } = useParams();
  const { data: documentData, postData: fetchData } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_FBOP,
  );

  const { data: updateData, postData: updateFbop } = usePostRequest(
    API_ENDPOINTS.UPDATE_SINGLE_FBOP,
  );

  const { data: deleted, postData: deleteFbop } = usePostRequest(
    API_ENDPOINTS.DELETE_SINGLE_FBOP,
  );

  const [zoom, setZoom] = useState(1);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [page, setPage] = useState(1);
  const [autoId, setAutoId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const imgUrl = process.env.REACT_APP_BASE_URL_IMG;

  // ─── Yup Schema ───────────────────────────────────────────────────────────
  const schema = yup.object().shape({
    reportDate: yup
      .date()
      .typeError("Report Date must be a valid date")
      .required("Report Date is required"),
    dateSized: yup
      .date()
      .typeError("Date Sized must be a valid date")
      .required("Date Sized is required"),
    sizedBy: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Sized By is required"),
    location: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Location is required"),
    firstName: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("First Name is required"),
    lastName: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Last Name is required"),
    height: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Height is required"),
    weight: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Weight is required"),
    chest: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Chest is required"),
    waist: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Waist is required"),
    frontSeated: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Front Seated is required"),
    frontStanding: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Front Standing is required"),
    back: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Back is required"),
    carrierType: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Carrier Type is required"),
    carrierQty: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Carrier Qty is required"),
    carryBag: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Carry Bag is required"),
    tails: yup
      .string()
      .transform((v) => (v === "" ? null : v))
      .nullable()
      .required("Tails is required"),
    comments: yup.string().optional(),
  });

  // ─── React Hook Form ───────────────────────────────────────────────────────
  const methods = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {},
  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = methods;

  // ─── Zoom / Drag handlers ──────────────────────────────────────────────────
  const handleZoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
  const handleZoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));

  const handleMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };
  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    setPosition({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y });
  };
  const handleMouseUp = () => setIsDragging(false);

  const navigate = useNavigate();
  // ─── Fetch page data ───────────────────────────────────────────────────────
  useEffect(() => {
    fetchData({ auto_id: zip_id, page });
  }, [zip_id, page]);

  // ─── Populate form when data arrives ──────────────────────────────────────
  useEffect(() => {
    if (documentData?.data) {
      const data = documentData.data;
      setAutoId(data?.auto_id);
      setValue(
        "reportDate",
        data?.date ? moment(data.date).format("MM/DD/YYYY") : null,
      );
      setValue(
        "dateSized",
        data?.date_sized ? moment(data.date_sized).format("MM/DD/YYYY") : null,
      );
      setValue("sizedBy", data.sized_by || null);
      setValue("location", data.fbop_loc || null);
      setValue("firstName", data.officer_first_name || null);
      setValue("lastName", data.officer_last_name || null);
      setValue("height", data.height || null);
      setValue("weight", data.weight || null);
      setValue("chest", data.chest || null);
      setValue("waist", data.waist || null);
      setValue("frontSeated", data.front_seated || null);
      setValue("frontStanding", data.front_standing || null);
      setValue("back", data.back || null);
      setValue("carrierType", data.v_carrier_type || null);
      setValue("carrierQty", data.v_carrier_qty || null);
      setValue("carryBag", data.v_carry_bag || null);
      setValue("tails", data.v_tails || null);
      setValue("comments", data.additional_comments || null);
    }
  }, [documentData, setValue]);

  // ─── Update submit handler ─────────────────────────────────────────────────
  const onSubmit = (data) => {
    const payload = {
      auto_id: autoId,
      date: data.reportDate
        ? moment(data.reportDate).format("YYYY-MM-DD")
        : null,
      date_sized: data.dateSized
        ? moment(data.dateSized).format("YYYY-MM-DD")
        : null,
      sized_by: data.sizedBy || null,
      fbop_loc: data.location || null,
      officer_first_name: data.firstName || null,
      officer_last_name: data.lastName || null,
      height: data.height || null,
      weight: data.weight || null,
      chest: data.chest || null,
      waist: data.waist || null,
      front_seated: data.frontSeated || null,
      front_standing: data.frontStanding || null,
      back: data.back || null,
      v_carrier_type: data.carrierType || null,
      v_carrier_qty: data.carrierQty || null,
      v_carry_bag: data.carryBag || null,
      v_tails: data.tails || null,
      additional_comments: data.comments || null,
    };

    updateFbop(payload, onSuccess, onError);
  };

  const openModal = () => {
    let modalMessage = "Are you sure you want to delete this form?";
    let modalTitle = "Delete FBOP Form";
    let type = "danger";
    let modalIcon = <IconTrash />;
    let actionHandler = () => {
      const payload = {
        auto_id: autoId,
      };
      deleteFbop(payload, onDeleteSuccess, onDeleteError);
    };
    let action = "delete";
    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const handleDeleteFbop = () => {
    const payload = {
      auto_id: autoId,
    };
    deleteFbop(payload, onDeleteSuccess, onDeleteError);
  };

  const onDeleteSuccess = (response) => {
    toast.success(
      response?.message || "The record has been successfully deleted",
    );
    navigate("/list-fbop");
  };

  const onDeleteError = (error) => {
    toast.error(error?.message || "Error deleting the record");
  };

  const onSuccess = (response) => {
    toast.success(response?.message || "Updated FBOP Form Successfully");
  };

  const onError = (errs) => {
    console.log("FBOP Validation errors:", errs);
    toast.error(errs?.message || "Error Updating FBOP Form");
  };

  // ─── Styles ────────────────────────────────────────────────────────────────
  const customStyles = {
    dotBackground: {
      backgroundColor: "#f8fafc",
      backgroundImage: "radial-gradient(#cbd5e1 1px, transparent 0)",
      backgroundSize: "24px 24px",
      borderRadius: "8px",
      overflow: "hidden",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: isDragging ? "grabbing" : zoom > 1 ? "grab" : "default",
    },
    imageStyle: {
      transition: isDragging ? "none" : "transform 0.3s ease",
      transform: `translate(${position.x}px, ${position.y}px) scale(${zoom})`,
      maxWidth: "90%",
      maxHeight: "90%",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      borderRadius: "4px",
      userSelect: "none",
    },
    sectionTitle: {
      fontSize: "12px",
      fontWeight: "700",
      color: "#94a3b8",
      letterSpacing: "0.05em",
      borderLeft: "3px solid #1e293b",
      paddingLeft: "10px",
    },
    inputStyle: {
      // backgroundColor: "#f8fafc",
      backgroundColor: "#ffffff",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      fontSize: "14px",
      color: "#334155",
    },
    unitAddon: {
      backgroundColor: "#ffffff",
      // backgroundColor: "#f1f5f9",
      border: "1px solid #e2e8f0",
      fontSize: "12px",
      color: "#94a3b8",
      padding: "0 12px",
    },
  };

  // ─── Reusable error message component ─────────────────────────────────────
  const ErrorMsg = ({ field }) =>
    errors[field] ? (
      <Form.Text className="text-danger" style={{ fontSize: "11px" }}>
        {errors[field].message}
      </Form.Text>
    ) : null;

  return (
    <>
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
      <FormProvider {...methods}>
        <Form autoComplete="off" onSubmit={handleSubmit(onSubmit, onError)}>
          {/* bg-light removed */}
          <div className="bg-light min-vh-100 p-4">
            <Container>
              <Row className="g-4">
                <Col lg={7}>
                  <Card
                    className="border-0 shadow-sm rounded-4 overflow-hidden"
                    style={{ height: "85vh" }}
                  >
                    <div className="p-3 flex-grow-1 d-flex flex-column h-100">
                      <div
                        className="flex-grow-1 border p-2"
                        style={customStyles.dotBackground}
                        onMouseDown={handleMouseDown}
                        onMouseMove={handleMouseMove}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp}
                      >
                        <div className="position-absolute top-0 end-0 m-3 d-flex flex-column gap-2 z-3">
                          <Button
                            onClick={handleZoomIn}
                            variant="light"
                            className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                            style={{
                              width: "30px",
                              height: "30px",
                              minWidth: "auto",
                              backgroundColor: "#fff",
                            }}
                          >
                            <IconPlus size={16} stroke={2.5} />
                          </Button>
                          <Button
                            onClick={handleZoomOut}
                            variant="light"
                            className="rounded-circle d-flex align-items-center justify-content-center p-0 shadow-sm"
                            style={{
                              width: "30px",
                              height: "30px",
                              minWidth: "auto",
                              backgroundColor: "#fff",
                            }}
                          >
                            <IconMinus size={16} stroke={2.5} />
                          </Button>
                        </div>
                        <img
                          src={`${imgUrl}${documentData?.data?.image}`}
                          alt="Document"
                          style={customStyles.imageStyle}
                          draggable={false}
                        />
                      </div>

                      <div className="pt-3 d-flex justify-content-between align-items-center">
                        <span className="text-muted small fw-medium d-flex flex-row align-items-center gap-3">
                          Page {page} of {documentData?.totalRecords}
                          <div className="d-flex gap-2">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1"
                              style={{
                                fontSize: "0.85rem",
                                borderColor: "#db4a22",
                                color: "#db4a22",
                                backgroundColor: "transparent",
                              }}
                              onClick={openModal}
                            >
                              Delete <IconTrash size={14} />
                            </Button>
                            {/* Update button — triggers Yup validation via handleSubmit */}
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              className="px-3 border-light-subtle rounded-3 d-flex align-items-center gap-1"
                              type="submit"
                            >
                              Update
                            </Button>
                          </div>
                        </span>
                        <div className="d-flex gap-2">
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            className="px-3 border-light-subtle rounded-3 d-flex align-items-center gap-1"
                            onClick={() => setPage((prev) => prev - 1)}
                            disabled={page <= 1}
                          >
                            <IconChevronLeft size={16} /> Previous
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            className="px-3 border-light-subtle rounded-3 d-flex align-items-center gap-1"
                            onClick={() => setPage((prev) => prev + 1)}
                            disabled={page >= documentData?.totalRecords}
                          >
                            Next <IconChevronRight size={16} />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Col>

                <Col lg={5}>
                  <Card
                    className="border-0 shadow-sm rounded-4 overflow-hidden"
                    style={{ height: "85vh" }}
                  >
                    <Card.Header className="bg-white border-bottom p-3 d-flex justify-content-between align-items-center pt-4">
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="p-1 rounded-2"
                          style={{ backgroundColor: "#f0f2ff" }}
                        >
                          <IconBolt size={20} color="#FE6338" fill="#FE6338" />
                        </div>
                        <h6
                          className="mb-0 fw-bold"
                          style={{ color: "#1e293b" }}
                        >
                          Extracted Data
                        </h6>
                      </div>
                    </Card.Header>

                    <div
                      className="overflow-auto flex-grow-1 p-4 pt-2"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      {/* ── GENERAL INFORMATION ── */}
                      <div
                        className="mt-2 mb-3"
                        style={customStyles.sectionTitle}
                      >
                        GENERAL INFORMATION
                      </div>

                      <Row className="g-3 mb-3">
                        <Col>
                          <Form.Label className="fw-semibold">
                            Report Date
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("reportDate")}
                            isInvalid={!!errors.reportDate}
                          />
                          <ErrorMsg field="reportDate" />
                        </Col>
                        <Col>
                          <Form.Label className="fw-semibold">
                            Date Sized
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("dateSized")}
                            isInvalid={!!errors.dateSized}
                          />
                          <ErrorMsg field="dateSized" />
                        </Col>
                      </Row>

                      <Row className="g-3 mb-3">
                        <Col>
                          <Form.Label className="fw-semibold">
                            Sized By
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("sizedBy")}
                            isInvalid={!!errors.sizedBy}
                          />
                          <ErrorMsg field="sizedBy" />
                        </Col>
                        <Col>
                          <Form.Label className="fw-semibold">
                            Location
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("location")}
                            isInvalid={!!errors.location}
                          />
                          <ErrorMsg field="location" />
                        </Col>
                      </Row>

                      <div
                        className="mt-4 mb-3"
                        style={customStyles.sectionTitle}
                      >
                        OFFICER DETAILS
                      </div>

                      <Row className="g-3 mb-3">
                        <Col>
                          <Form.Label className="fw-semibold">
                            First Name
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("firstName")}
                            isInvalid={!!errors.firstName}
                          />
                          <ErrorMsg field="firstName" />
                        </Col>
                        <Col>
                          <Form.Label className="fw-semibold">
                            Last Name
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("lastName")}
                            isInvalid={!!errors.lastName}
                          />
                          <ErrorMsg field="lastName" />
                        </Col>
                      </Row>

                      <div
                        className="mt-4 mb-3"
                        style={customStyles.sectionTitle}
                      >
                        MEASUREMENTS
                      </div>

                      <Row className="g-3 mb-3">
                        <Col md={6}>
                          <Form.Label className="fw-semibold">
                            Height
                          </Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("height")}
                              isInvalid={!!errors.height}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="height" />
                        </Col>
                        <Col md={6}>
                          <Form.Label className="fw-semibold">
                            Weight
                          </Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("weight")}
                              isInvalid={!!errors.weight}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              lbs
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="weight" />
                        </Col>
                        <Col md={6}>
                          <Form.Label className="fw-semibold">Chest</Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("chest")}
                              isInvalid={!!errors.chest}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="chest" />
                        </Col>
                        <Col md={6}>
                          <Form.Label className="fw-semibold">Waist</Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("waist")}
                              isInvalid={!!errors.waist}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="waist" />
                        </Col>
                      </Row>

                      <Row className="mb-4 g-2">
                        <Col xs={4}>
                          <Form.Label className="fw-semibold">
                            Fr. Seated
                          </Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("frontSeated")}
                              isInvalid={!!errors.frontSeated}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="frontSeated" />
                        </Col>
                        <Col xs={4}>
                          <Form.Label className="fw-semibold">
                            Fr. Standing
                          </Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("frontStanding")}
                              isInvalid={!!errors.frontStanding}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="frontStanding" />
                        </Col>
                        <Col xs={4}>
                          <Form.Label className="fw-semibold">Back</Form.Label>
                          <InputGroup>
                            <Form.Control
                              style={customStyles.inputStyle}
                              {...register("back")}
                              isInvalid={!!errors.back}
                            />
                            <InputGroup.Text style={customStyles.unitAddon}>
                              in
                            </InputGroup.Text>
                          </InputGroup>
                          <ErrorMsg field="back" />
                        </Col>
                      </Row>

                      <div
                        className="mt-4 mb-3"
                        style={customStyles.sectionTitle}
                      >
                        EQUIPMENT
                      </div>

                      <Row className="mb-4 g-3">
                        <Col xs={6}>
                          <Form.Label className="fw-semibold">
                            Carrier Type
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            {...register("carrierType")}
                            isInvalid={!!errors.carrierType}
                          />
                          <ErrorMsg field="carrierType" />
                        </Col>
                        <Col xs={6}>
                          <Form.Label className="fw-semibold">
                            Carrier Qty
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            {...register("carrierQty")}
                            isInvalid={!!errors.carrierQty}
                          />
                          <ErrorMsg field="carrierQty" />
                        </Col>
                        <Col xs={6}>
                          <Form.Label className="fw-semibold">
                            Carry Bag
                          </Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            {...register("carryBag")}
                            isInvalid={!!errors.carryBag}
                          />
                          <ErrorMsg field="carryBag" />
                        </Col>
                        <Col xs={6}>
                          <Form.Label className="fw-semibold">Tails</Form.Label>
                          <Form.Control
                            style={customStyles.inputStyle}
                            {...register("tails")}
                            isInvalid={!!errors.tails}
                          />
                          <ErrorMsg field="tails" />
                        </Col>
                      </Row>

                      <div
                        className="mt-4 mb-3"
                        style={customStyles.sectionTitle}
                      >
                        COMMENTS
                      </div>

                      <Row className="mb-3">
                        <Col xs={12}>
                          <Form.Label className="fw-semibold">
                            Additional Comments
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            style={customStyles.inputStyle}
                            className="py-2"
                            {...register("comments")}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </Form>
      </FormProvider>
    </>
  );
}

export default FBOPForm;
